import { RequestService } from "../../../../../common/services/RequestService";
import { GET_ORDER_REPORT } from "../constants";

export const getOrderReportRequest = async orderId => {
  const response = await RequestService.get(
    GET_ORDER_REPORT.replace("{order_id}", orderId)
  );
  return response.data;
};
